import { API_ENDPOINTS } from '@/constants/endpoints';
import { ProductRecommendationAdapter, type ProductRecommendationResponseDto, type RecommendationOptionsResponseDto } from '@/adapters/product-recommendation.adapter';
import { api } from '@/lib/api';
import { withBuScope } from '@/lib/business-unit-scope';
import { productService } from './product.service';
import type { ApiResponse } from '@/types';
import type { RecommendationClient } from '@/types';
const endpoint = API_ENDPOINTS.PRODUCTS.RECOMMENDATIONS;
export const productRecommendationService: RecommendationClient = {
  async get(scope) {
    const response = await api.get<ApiResponse<ProductRecommendationResponseDto>>(endpoint, { params: { bu_id: scope || undefined } });
    return ProductRecommendationAdapter.fromApi(response.data.data);
  },
  async save(scope, config) {
    const { promoted, excluded } = config;
    const response = await api.put<ApiResponse<ProductRecommendationResponseDto>>(withBuScope(endpoint, scope ? { bu_id: scope } : {}), { promoted, excluded });
    return ProductRecommendationAdapter.fromApi(response.data.data);
  },
  async options(scope, kind, query, cursor, group) {
    const response = await api.get<ApiResponse<RecommendationOptionsResponseDto>>(API_ENDPOINTS.PRODUCTS.RECOMMENDATION_OPTIONS, { params: { bu_id: scope || undefined, kind, query, cursor, groupKind: group?.kind, groupId: group?.id } });
    return ProductRecommendationAdapter.optionsFromApi(response.data.data);
  },
  async setProductBlocked(scope, productId, blocked) {
    await productService.toggleBlock(productId, blocked, scope ? { bu_id: scope } : {});
  },
};
